import { useMutation } from '@tanstack/react-query'
import defaultConfig from 'const/config'
import {
  AuthorizeMutationResult,
  AuthorizeUseMutationProps
} from './authorizeMutation.types'
import { getAuthorizeOptions } from './authorizeMutationOptions'

const defaultOptions = { config: defaultConfig }
/**
 * Calls the authorize endpoint the 2nd time, during deferred auth flow.
 * This happens after IDP authentication succeeds, so we signal to global auth to grant us an auth code
 * that we need for an access token. If successful, it will 302 redirect to the token callback page.
 * https://developer.syf.com/api-reference/oauth2-api-v3-v3#operation/Form%20Post%20Authorize
 * @param props @see {@link AuthorizeUseMutationProps} - options for the authorize query
 * @returns the same as useMutation returns, an obj with .data and other query stuff
 */
const useAuthorizeMutation = ({
  config = defaultConfig,
  mutationOptions = {}
}: AuthorizeUseMutationProps = defaultOptions): AuthorizeMutationResult => {
  const authorizeMutationOptions = getAuthorizeOptions({
    config,
    mutationOptions
  })

  return useMutation(authorizeMutationOptions)
}

export default useAuthorizeMutation
